import { IRegionCity } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-by-region';
import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';
import { IRegionWithCities } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';

import * as ST from './styled';

interface IProps {
    isRegionOpen: boolean,
    region: IRegionWithCities,
    onRegionSelect: (region: IRegionWithCities) => void,
    onCitySelect: (city: ICitySatellite) => void,
}

const RegionElement = ({ isRegionOpen, region, onRegionSelect, onCitySelect }: IProps): JSX.Element => {
    const citySelectHandler = (city: IRegionCity) => {
        const { name, domain, provider_id } = city;
        onCitySelect({ name, domain, provider_id });
    };

    return (
        <ST.RegionElement>
            <ST.RegionTitle
                isOpen={isRegionOpen}
                onClick={() => onRegionSelect(region)}
                data-test='title'
            >
                {region.name}
            </ST.RegionTitle>
            {isRegionOpen && !!region.cities?.length && (
                <ST.CitiesWrap isOpen={isRegionOpen}>
                    {region.cities?.map((city, index) => {
                        const { name: cityName, domain, provider_id, main } = city;
                        return (
                            <ST.CityItem
                                key={`${domain}_${provider_id}_${index}`}
                                isMain={!!main}
                                onClick={() => citySelectHandler(city)}
                                data-test='city-item'
                            >
                                {cityName}
                            </ST.CityItem>
                        );
                    })}
                </ST.CitiesWrap>
            )}
        </ST.RegionElement>
    );
};

export default RegionElement;
